
<kendo-card  >
  <kendo-card-header>
    User information
  </kendo-card-header>
  <div *ngIf="auth.user$ | async as user">
  <img
    [src]="user.picture"
    height="90"
    width="90"
  />

  <h2>{{ user.name }}</h2>
  <h2>{{ user.email }}</h2>
  </div>

  <app-appversion></app-appversion>
  <app-connection></app-connection>

</kendo-card>

